/**************************************************
 * Nombre:       Detalle_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Producto_Imangenes from "./SubComponentes/Producto_Imangenes";
import Producto_Especificaciones from "./SubComponentes/Producto_Especificaciones";
import Producto_Detalle from "./SubComponentes/Producto_Detalle";
import Producto_Metodos from "./SubComponentes/Producto_Metodos";
import Productos_Formulario from "./SubComponentes/Productos_Formulario";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Detalle_Producto = () => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}

            >

                <Grid container size={{xs: 11, sm: 11, md: 10}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{
                            maxWidth: '1400px',
                            p: !masSM ? 2 : 6,
                            backgroundColor: '#fff',
                            borderTopRightRadius: 16,
                            borderTopLeftRadius: 16
                        }}
                        spacing={3}
                    >


                        <Grid container size={{xs: 12, sm: 6, md: 7}} sx={{justifyContent: 'flex-start'}}>

                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Producto_Imangenes/>
                                </Grid>

                                {!sCell &&
                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Producto_Especificaciones/>
                                </Grid>
                                }

                            </Grid>

                        </Grid>

                        <Grid container size={{xs: 12, sm: 6, md: 5}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Producto_Detalle/>
                                </Grid>

                                {sCell &&
                                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                        <Producto_Especificaciones/>
                                    </Grid>
                                }

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Producto_Metodos/>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 2}}>
                                    <Productos_Formulario/>
                                </Grid>

                            </Grid>

                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Detalle_Producto